// extracted by mini-css-extract-plugin
module.exports = {"inline":"switch-item_inline__ZpmU4","root":"switch-item_root__nZxNK"};